import { Injectable } from '@angular/core';
import { OrganizationId } from '../helpers/organizationId-helper';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  /**
   * Gets the organization ID from current user data
   * @param currentUser - The current user object from localStorage
   * @returns The organization ID as string
   */
  getOrganizationId(currentUser: any): string {
    // First try to get from board.organisationId, fallback to board.organisation.id
    const organizationId = currentUser?.board?.organisationId 
      ? currentUser.board.organisationId 
      : currentUser?.board?.organisation?.id;

    // Map the organization ID to the enum value, defaulting to 1 if organisationId exists, 2 otherwise
    const mappedId = organizationId
      ? OrganizationId[organizationId as keyof typeof OrganizationId] ?? 1
      : 2;

    return String(mappedId);
  }

  getLegacyOrganizationId(currentUser: any): string {
    // First try to get from board.organisationId, fallback to board.organisation.id
    const organizationId = currentUser?.board?.organisationId 
      ? currentUser.board.organisationId 
      : currentUser?.board?.organisation?.id;

    return String(organizationId);
  }

  /**
   * Sets the organization ID in localStorage
   * @param currentUser - The current user object
   */
  setOrganizationIdInStorage(currentUser: any): void {
    const organizationId = this.getOrganizationId(currentUser);
    localStorage.setItem('organizationId', organizationId);
  }

  /**
   * Gets the organization prefix (dk/no) from organization ID
   * @param currentUser - The current user object from localStorage
   * @returns The organization prefix ('dk' or 'no')
   */
  getOrganizationPrefix(currentUser: any): string {
    const organizationId = currentUser?.board?.organisationId 
      ? currentUser.board.organisationId 
      : currentUser?.board?.organisation?.id;

    switch (organizationId) {
      case '2195ed89-bd12-4e27-9bdf-d8fcd9b8f14d':
        return 'dk';
      case 'b8f77630-9666-4627-b234-f4a1b5329e17':
        return 'no';
      default:
        return 'dk'; // Default fallback
    }
  }
}
